'use strict';

/**
 * Expanded detail for one high-level tracker stage: the publication graph
 * and a small status legend. Selecting a pizza-tracker stage highlights
 * the matching graph nodes.
 */

import React, { useMemo } from 'react';
import { Box, Chip, Stack } from '@mui/material';
import { PipelineStatusGraph } from './components/PipelineStatusGraph';

function GraphLegend() {
	return (
		<Stack direction="row" spacing={1} sx={{ my: 1, flexWrap: 'wrap' }} aria-label="Graph legend">
			<Chip size="small" variant="outlined" color="info" label="Started = in progress" />
			<Chip size="small" variant="outlined" color="success" label="Completed = done" />
			<Chip size="small" variant="outlined" color="error" label="Failed = needs attention" />
			<Chip size="small" variant="outlined" label="No chip = no data yet" />
		</Stack>
	);
}

/**
 * @param {{
 *   step: import('./pipelineProgressModel').PipelineProgressStep | undefined;
 *   stages: import('./pipelineStatusTypes').PipelineStatusStage[];
 * }} props
 */
export function PipelineStageDetails({ step, stages }) {
	const highlightedIds = useMemo(
		() => (step ? step.subSteps.map((s) => s.id) : []),
		[step],
	);

	if (!step && !(Array.isArray(stages) && stages.length > 0)) return null;

	return (
		<Box data-testid="pipeline-stage-details" sx={{ pt: 1.5 }}>
			<GraphLegend />
			<PipelineStatusGraph stages={stages} highlightedStageIds={highlightedIds} />
		</Box>
	);
}
